import { SkipButton } from 'components/parts/SkipButton';
import { cx } from 'utils/cx';

import styles from './Screen.module.scss';

type ScreenProps = {
  hidePrevButton?: boolean;
  hideNextButton?: boolean;
  onPrevStep: () => void;
  onNextStep: () => void;
  onSkipDialogue: () => void;
  screen?: 'sky' | 'home';
  light?: 'lighting' | 'lightUp' | 'lightDown';
  children: React.ReactNode;
};

export const Screen = ({
  hidePrevButton = false,
  hideNextButton = false,
  onNextStep,
  onPrevStep,
  onSkipDialogue,
  screen = 'home',
  light,
  children,
}: ScreenProps) => {
  return (
    <>
      <div className={styles.fullScreen}>
        <div className={styles.skipButtonRoot}>
          <SkipButton onClick={onSkipDialogue} />
        </div>
        <div
          className={[styles.background, styles[`--${screen}`], light && styles[`--${light}`]].join(
            ' '
          )}
        ></div>
        {children}
        <button
          className={cx(styles.prev, hidePrevButton && styles['--hidden'])}
          type="button"
          onClick={onPrevStep}
        >
          <img src={require('images/icon/prev.webp')} alt="前へ" className={styles.prevIcon} />
        </button>
        <button
          className={cx(styles.next, hideNextButton && styles['--hidden'])}
          type="button"
          onClick={onNextStep}
        >
          <img src={require('images/icon/next.webp')} alt="次へ" className={styles.nextIcon} />
        </button>
      </div>
    </>
  );
};
